import React, { useEffect, useRef } from "react";
import track from "@/lib/track";

const API = process.env.REACT_APP_BACKEND_URL;

// Clip embebido de un paso: mudo, en loop, autoplay, sin controles. Si no hay clip, no renderiza nada.
// Si recibe pantalla/paso_key, mide el uso: cada vez que el loop vuelve a empezar emite `clip_repetido`
// y, al desmontarse, emite `clip_reproducido` con cuántas veces seguidas se repitió.
export const ClipVideo = ({ clipId, className = "", pantalla, forma, paso_key }) => {
  const rep = useRef(0);
  const played = useRef(false);
  const lastTime = useRef(0);
  const midiendo = !!(pantalla && (paso_key !== undefined && paso_key !== null));

  useEffect(() => {
    return () => {
      if (midiendo && played.current) {
        track("clip_reproducido", { pantalla, forma: forma || null, paso_key: String(paso_key), repeticiones: rep.current });
      }
    };
    // eslint-disable-next-line
  }, [clipId]);

  if (!clipId) return null;

  const onTimeUpdate = (e) => {
    const t = e.target.currentTime || 0;
    played.current = true;
    // El loop reinicia el tiempo: si salta hacia atrás, volvió a empezar.
    if (midiendo && t + 0.35 < lastTime.current) {
      rep.current += 1;
      track("clip_repetido", { pantalla, forma: forma || null, paso_key: String(paso_key), vuelta: rep.current });
    }
    lastTime.current = t;
  };

  return (
    <div className={`mb-3 ${className}`} data-testid={`clip-${clipId}`}>
      <div className="mono-label mb-1.5" style={{ fontSize: "10px", color: "#8A8A8A", textTransform: "lowercase", letterSpacing: "0.02em" }}>
        así se ve
      </div>
      <video
        src={`${API}/api/clip-video/${clipId}`}
        autoPlay
        loop
        muted
        playsInline
        controls={false}
        onTimeUpdate={onTimeUpdate}
        className="w-full"
        style={{ borderRadius: 10, border: "1px solid #2A2A2A", display: "block", background: "#0A0A0A" }}
        data-testid="clip-video"
      />
    </div>
  );
};

export default ClipVideo;
